import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { ContentImageTo3d } from './ContentImageTo3d';

export type ContentImageTo3dContainerProps = {};

const LOCALSTORAGE_KEY = 'IMAGE_TO_3D_PROVIDER';

export function ContentImageTo3dContainer(_props: ContentImageTo3dContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const credits = useSelector(selectors.base.$credits);
  const user = useSelector(selectors.base.$user);
  const { tsStartExternal, externalGlb } = appState;
  const [isTrellis, setIsTrellis] = useLocalStorage(LOCALSTORAGE_KEY, true);
  const [source, setSource] = useState('sample');

  const { isEmployee } = user;

  const callbacks = useMemo(
    () => ({
      onGenerate: (file: File, source: string) => {
        dispatch({
          type: 'TRELLIS',
          verb: 'generate',
          payload: {
            file,
            source,
            version: isTrellis ? 'trellis' : 'hunyuan',
          },
        });

        setSource(source);
      },
      onDownload: (externalGlb: string) => {
        dispatch({
          type: 'TRELLIS',
          verb: 'download',
          payload: {
            externalGlb,
            source,
          },
        });
      },
      onToggleProvider: (value: boolean) => {
        setIsTrellis(value);
      },
    }),
    [isTrellis, source]
  );

  return (
    <ContentImageTo3d
      isTrellis={isTrellis}
      isEmployee={isEmployee}
      credits={credits}
      externalGlb={externalGlb}
      tsStart={tsStartExternal}
      callbacks={callbacks}
    />
  );
}

export default ContentImageTo3dContainer;
